import { Title } from "@mantine/core";
import type { ReactNode } from "react";

interface ISSHeadLineHeaderProps {
  children: ReactNode;
}

/**
 * Default header for Headline props
 * Make text with padding and greyish bg, and white font
 * */
const SSHeadLineHeader: React.FC<ISSHeadLineHeaderProps> = ({ children }) => {
  return (
    <div className="mx-3 mb-[24px] max-w-fit grow-0 rounded-full bg-primary-default/70 px-[20px] py-[10px] backdrop-blur-lg">
      <Title
        className="font-inter font-normal text-primary-white text-sm"
        order={1}
        ta={"center"}
      >
        {children}
      </Title>
    </div>
  );
};

export default SSHeadLineHeader;
